import React, {useCallback, useState} from "react";
import {connect} from "react-redux";
import {createBottomTabNavigator} from "@react-navigation/bottom-tabs";
import ContinueGameScreen from "./ContinueGameScreen";
import HomeIcon from "../../icons/HomeIcon";
import Colors from "../../styles/colors";
import GameOptionsIcon from "../../icons/GameOptionsIcon";
import ManageProfileScreen from "./ManageProfileScreen";
import ProfileIcon from "../../icons/ProfileIcon";
import {useFocusEffect} from "@react-navigation/core";
import GameStatisticsScreen from "./GameStatisticsScreen";
import MessagesScreen from "./MessagesScreen";
import GameStatsIcon from "../../icons/GameStatsIcon";
import { useWindowDimensions, View } from "react-native";
import ChatIcon from "../../icons/ChatIcon";
import Api from "../../services/Api";
import { subscribeToChatUpdates } from "../../services/Wamp";
import Badge from "../../sharedComponents/badge/badge";
import StandardText from "../../sharedComponents/standardText/StandardText";
import useUnreadChatMessageCount from "../../hooks/useUnreadChatMessageCount";
import { useHffeNavigation } from "../../hooks/useHffeNavigation";

const Tab = createBottomTabNavigator();

const HomeScreen = ({navigation, userAccount, accessToken}) => {
    const unreadMessageCount = useUnreadChatMessageCount(accessToken);
    const hffeNavigation = useHffeNavigation(navigation);

    useFocusEffect(useCallback(() => {
        zE('webWidget', 'show');
    }, [navigation]));

    useFocusEffect(useCallback(() => {
        if (userAccount?.user && userAccount.user.email === null) {
            navigation.navigate('CompleteUserAccountInfo');
        }
    }, [userAccount]));

    const defaultTitle = 'Hand & Foot Friends & Family Edition';

    const screenOptions = ({route}) => ({
        tabStyle: {
            display: 'none',
        },
        tabBarIcon: ({focused}) => {
            if (route.name === 'ContinueGame') {
                return <HomeIcon size={32} color={focused ? Colors.onBackground : Colors.onBackgroundBorder}/>
            } else if (route.name === 'GameOptions') {
                return <GameOptionsIcon size={42} color={focused ? Colors.onBackground : Colors.onBackgroundBorder}/>
            } else if (route.name === 'GameStatistics') {
                return <GameStatsIcon size={34} color={focused ? Colors.onBackground : Colors.onBackgroundBorder}/>
            } else if (route.name === 'ManageProfile') {
                return <ProfileIcon size={32} color={focused ? Colors.onBackground : Colors.onBackgroundBorder}/>
            } else if (route.name === 'Messages') {
                return <View style={{ position: "relative", display: "flex", flexDirection: "row", alignItems: "center" }}>
                    {!userAccount?.tags?.includes("has-seen-messages") && (<View style={{ position: "absolute", left: -20, top: 4 }}>
                        <Badge>
                            <StandardText style={{ fontSize: 'inherit', color: 'inherit' }}>NEW</StandardText>
                        </Badge>
                    </View>)}
                    {unreadMessageCount > 0 && <View
                        style={{
                            position: "absolute",
                            top: 0,
                            right: -8,
                            backgroundColor: Colors.secondary,
                            borderRadius: 32,
                            width: 20,
                            height: 20,
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center'
                        }}>
                            <StandardText style={{ fontSize: 11, color: Colors.onPrimary, fontWeight: 700, textAlign: 'center'}}>
                                {unreadMessageCount > 99 ? '99+' : unreadMessageCount}
                            </StandardText>
                        </View>}
                    <ChatIcon size={32} color={focused ? Colors.onBackground : Colors.onBackgroundBorder}/>
                </View>
            }
        }
    });

    const { width, height} = useWindowDimensions();
    const isSmallScreen = width < 800;
    const tabStyle = isSmallScreen ? {marginLeft: 48} : {};

    return (
        <Tab.Navigator screenOptions={screenOptions} tabBarOptions={{showLabel: false, tabStyle: tabStyle }} initialRouteName={'ContinueGame'}>
            <Tab.Screen name="ContinueGame" component={ContinueGameScreen} options={{title: defaultTitle}} />
            <Tab.Screen name="GameStatistics" component={GameStatisticsScreen} options={{title: defaultTitle}}/>
            <Tab.Screen name="ManageProfile" component={ManageProfileScreen} options={{title: defaultTitle}}/>
            <Tab.Screen name="Messages" component={MessagesScreen} options={{title: defaultTitle}} listeners={({navigation}) => ({
                tabPress: (e) => {
                    e.preventDefault();
                    navigation.navigate(...hffeNavigation.gotoMessagesArgs());
                },
            })} />
        </Tab.Navigator>
    );
};

const mapStateToProps = (state) => {
    return {
        userAccount: state.auth.login.userAccount,
        accessToken: state.auth.login.accessToken,
    }
};

export default connect(mapStateToProps)(HomeScreen);
